import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class CommonService {
    constructor(private http: HttpClient
    ) { }

    public validateAllFormFields(form) {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }

}





// WEBPACK FOOTER //
// ./src/app/core/shared/common.service.ts